<template>
  <div class="registerCardStyle">
    <UserBase
      :title="getTitle"
      :description="getDescription"
      :isShowToLogin="!typeEmail"
    >
      <template #default>
        <v-row no-gutters class="pb-2" justify="center" align-content="center">
          <v-col cols="10">
            <v-text-field
              v-model="userInfo.mail"
              :placeholder="$t('common.input_mailaddress')"
              outlined
              dense
              hide-details
              height="36"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" align-content="center">
          <v-col cols="10">
            <NormalButton
              :text="$t('common.input_order-send')"
              height="50px"
              :disabled="!userInfo.mail || isDisabled"
              @click="execRegisterUser"
            />
          </v-col>
        </v-row>
      </template>
    </UserBase>
  </div>
</template>
<script>
import { UserBase } from '@/components/layouts'

import { NormalButton } from '@/components/items'
import { mapActions } from 'vuex'

export default {
  components: {
    UserBase,
    NormalButton
  },
  data: () => {
    return {
      userInfo: {
        mail: ''
      },
      isDisabled: false,
      typeEmail: false
    }
  },
  computed: {
    getTitle() {
      return this.typeEmail
        ? this.$t('user.user_resetting-a-mail-address')
        : this.$t('user.user_resetting-a-password')
    },
    getDescription() {
      return this.typeEmail
        ? this.$t('user.user_input-new-mail-address')
        : this.$t('user.user_input-mail-address')
    }
  },
  mounted() {
    this.typeEmail = this.$route.query.type === 'email'
  },
  methods: {
    ...mapActions('User', ['changeMailAddress', 'sendMailForResetPassword']),
    async execRegisterUser() {
      this.isDisabled = true
      let isSucceed = false
      if (this.typeEmail) {
        // メールアドレス変更
        isSucceed = await this.changeMailAddress({
          email: this.userInfo.mail
        })
        if (isSucceed) {
          this.$router.push({
            name: 'user.password-reset-mail.success',
            query: {
              type: 'email'
            }
          })
        }
      } else {
        // パスワード再設定
        isSucceed = await this.sendMailForResetPassword({
          email: this.userInfo.mail
        })
        if (isSucceed) {
          this.$router.push({
            name: 'user.password-reset-mail.success'
          })
        }
      }
      this.isDisabled = false
    }
  }
}
</script>

<style lang="scss" scoped>
.registerCardStyle {
  .terms {
    font-size: 12px !important;
  }
}
</style>
